import React from 'react';
import { Button } from '@mui/material';
import MenuBar from './MenuBar';
import Footer from './Footer';
import TagManager from 'react-gtm-module';

const TestEvents: React.FC = () => {
  const handleTestPurchaseEvent = () => {
    const formData = {
      email: 'test@example.com'
    };
    
    const priceCheck = {
      price: 3
    };

    TagManager.dataLayer({
      dataLayer: {
        event: 'purchase',
        description: 'personal',
        email: formData.email,
        value: priceCheck.price,
        num_licenses: 1,
        currency: 'USD',
        transaction_id: crypto.randomUUID()
      }
    });
    
    console.log('Purchase event fired with test data');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <MenuBar />
      <main style={{ flex: 1, padding: '2rem', textAlign: 'center' }}>
        <h1>Test Events</h1>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleTestPurchaseEvent}
          size="large"
          style={{ marginTop: '2rem' }}
        >
          Test Purchase Event
        </Button>
      </main>
      <Footer />
    </div>
  );
};

export default TestEvents;